var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftIconSpace = function SvgLeftIconSpace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 0C12.8435 2.96059e-16 13.013 0.0702379 13.1381 0.195262C13.2631 0.320286 13.3333 0.489856 13.3333 0.666667L13.3333 11.3333C13.3333 11.5101 13.2631 11.6797 13.1381 11.8047C13.013 11.9298 12.8435 12 12.6667 12L0.666667 12C0.489856 12 0.320286 11.9298 0.195262 11.8047C0.0702379 11.6797 4.44089e-16 11.5101 0 11.3333L0 0.666667C0 0.489856 0.0702379 0.320286 0.195262 0.195262C0.320286 0.0702379 0.489856 2.96059e-16 0.666667 0L12.6667 0ZM12 1.33333L1.33333 1.33333L1.33333 10.6667L12 10.6667L12 1.33333ZM10.6667 2.66667L10.6667 9.33333L9.33333 9.33333L9.33333 2.66667L10.6667 2.66667Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 1.33333 2)",
    fill: "rgb(9, 17, 30)"
  })));
};
export default SvgLeftIconSpace;